import { useState, useCallback, useLayoutEffect } from 'react'

const _leftDeltaValue = 3

export const useColorPickerState = () => {
  const [isOpen, setIsOpen] = useState(false)

  const open = useCallback(() => setIsOpen(true), [])
  const close = useCallback(() => setIsOpen(false), [])

  return {
    isOpenColorPicker: isOpen,
    closeColorPicker: close,
    openColorPicker: open
  }
}

export const useCalcColorPickerTopLeftCoords = (
  parentRef: null | HTMLDivElement,
  colorPickerWrapperRef: null | HTMLDivElement
) => {
  const [coords, setCoords] = useState({
    top: 0,
    left: 0
  })

  useLayoutEffect(() => {
    if (parentRef && colorPickerWrapperRef) {
      const parentRect = parentRef.getBoundingClientRect()
      const {
        left: parentLeft,
        top: parentTop,
        height: parentHeight
      } = parentRect

      const newTop = parentTop + parentHeight

      const wrapperRect = colorPickerWrapperRef.getBoundingClientRect()
      const { height: wrapperHeight } = wrapperRect

      const featureBottom = newTop + wrapperHeight

      if (featureBottom >= window.innerHeight) {
        setCoords({
          left: parentLeft - _leftDeltaValue,
          top: parentTop - wrapperHeight
        })
      } else {
        setCoords({ left: parentLeft - _leftDeltaValue, top: newTop })
      }
    }
  }, [parentRef, colorPickerWrapperRef])

  return coords
}
